/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function getAvailableFields(ChartOptionsUtil: any, localUserProfile: any, chartType: any, location: any): any[] {
  if (!chartType) {
    return [];
  }

  const chartOptions = ChartOptionsUtil.getOptions(chartType);
  if (!chartOptions || !chartOptions.fields) {
    return [];
  }

  const profile = localUserProfile.get().profile;
  const profileParam = chartOptions.chartTotalsOptions;
  const availableFields = _.get(profile, [profileParam, 'availableFields']);
  return _.filter(chartOptions.fields, function(f) {
    const isUserLimited = location.host === "localhost" || (f.user && f.user !== localUserProfile.get("username"));
    return !isUserLimited && (!availableFields || availableFields.indexOf(f.id) > -1);
  });
}
